<template>
  <main-layout>
    <v-tabs v-if="tabsVisible" slider-color="primary">
      <v-tab :to="{ name: 'lon-broadcast-main' }">LON Broadcast</v-tab>
      <v-tab :to="{ name: 'lon-broadcast-categories' }">{{ $t('category_management') }}</v-tab>
    </v-tabs>
    <router-view />
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAGE_GROUP } from '@/constants/page'

export default {
  computed: {
    ...mapGetters(['selectedBot']),
    tabsVisible() {
      return (
        [PAGE_GROUP.MY_ALLIANZ].includes(this.selectedBot.page_group) &&
        !['1718869589805'].includes(this.selectedBot.pageid)
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/LonBroadcastContainer.vue